import React, { Component } from "react";
import { connect } from "react-redux";
import InputComponent from "../../components/form/InputComponent";
import SelectComponent from "../../components/form/SelectComponent";
import { StyleSheet, css } from "aphrodite";
import SearchIcon from "@material-ui/icons/Search";
import {
  getExperienceListPending,
  getExperienceList,
  getExperienceListError,
} from "../../reducers/master-data/experience_reducer";
import Button from "@material-ui/core/Button";
import ModalAddPengalaman from "./Modal_add_pengalaman";
import { listCity } from "../../actions/master-data/city_action";
import {
  getCityListPending,
  getCityList,
  getCityListError,
} from "../../reducers/master-data/city_reducer";
import AddIcon from "@material-ui/icons/Add";
import _ from "lodash";
import { listHeaderStyles as shared } from "../../components/header/listHeaderStyles";

class HeaderPengalaman extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      status: "",
      modalAddPengalamanShow: false,
    };
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
  }

  delayedQuery = _.debounce((value) => {
    this.props.handleRefresh(value);
  }, 500);

  handleChangeSearch(e) {
    if (e !== null) {
      this.setState({ search: e.target.value });
      this.delayedQuery({ search: e.target.value });
    }
  }

  handleChangeStatus(e) {
    if (e !== null) {
      this.setState({ status: e.value });
      this.props.handleRefresh({ status: e.value });
    } else {
      this.props.handleRefresh({ status: "" });
    }
  }

  handleRefresh(state) {
    this.props.handleRefresh(state);
  }

  componentDidMount() {
    this.props.listCity({ page: 1, length: 999 });
  }

  render() {
    const { modalAddPengalamanShow } = this.state;
    const statusOption = [
      { value: 0, label: "Baru" },
      { value: 1, label: "Terverifikasi" },
      { value: 2, label: "Ditolak" },
    ];
    const { cityList_data } = this.props;
    let cityOption = [];
    if (cityList_data) {
      cityOption = cityList_data.data.map((value) => ({
        value: value.city_id,
        label: value.name,
      }));
    }

    return (
      <div className={css(shared.bar)}>
        <ModalAddPengalaman
          show={modalAddPengalamanShow}
          onHide={() =>
            this.setState({ modalAddPengalamanShow: false })
          }
          cityOption={cityOption}
          handleRefresh={this.handleRefresh}
        />
        <div className={css(shared.title)}>
          <Button
            variant="contained"
            color="primary"
            className={css(styles.approveButton, shared.buttonFull)}
            startIcon={<AddIcon />}
            onClick={() =>
              this.setState({ modalAddPengalamanShow: true })
            }
          >
            Tambah Pengalaman
          </Button>
        </div>
        <div className={css(shared.actions)}>
          <div className={css(shared.field)}>
            <InputComponent
              onChange={this.handleChangeSearch}
              value={this.state.search}
              placeholder="Cari Nama Institusi"
              startIcon={SearchIcon}
              id="search"
            />
          </div>
          <div className={css(shared.field)}>
            <SelectComponent
              onChange={this.handleChangeStatus}
              placeholder="Status"
              options={statusOption}
              id="status"
            />
          </div>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  approveButton: {
    background: "#2CB96A 0% 0% no-repeat padding-box",
    boxShadow: "none",
  },
});

function mapStateToProps({ experienceList, listCity }) {
  return {
    experienceList_pending: getExperienceListPending(experienceList),
    experienceList_data: getExperienceList(experienceList),
    experienceList_error: getExperienceListError(experienceList),
    cityList_pending: getCityListPending(listCity),
    cityList_data: getCityList(listCity),
    cityList_error: getCityListError(listCity),
  };
}

export default connect(mapStateToProps, { listCity })(
  HeaderPengalaman
);
